import { AnswerType } from './shared/enums/answer.enum';
import { Answer } from './models/answer/answer.model';
import { GapMatchAnswer } from './models/answer/gap-match-answer.model';
import { KeywordAnswer } from './models/answer/keyword-answer.model';
import { ListAnswer } from './models/answer/list-answer.model';
import { MultipleChoiceAnswer } from './models/answer/multiple-choice-answer.model';
import { OpenAnswer } from './models/answer/open-answer.model';
import { ReadingAnswer } from './models/answer/reading-answer.model';
import { ScaleAnswer } from './models/answer/scale-answer.model';
import { SelfExamAnswer } from './models/answer/self-exam-answer.model';

export class AnswerMapper {
  private static readonly mappers: Record<string, (dto: any) => Answer> = {
    [AnswerType.OPEN]: OpenAnswer.fromDto,
    [AnswerType.SCALE]: ScaleAnswer.fromDto,
    [AnswerType.SELF_EXAM]: SelfExamAnswer.fromDto,
    [AnswerType.MULTIPLE_CHOICE]: MultipleChoiceAnswer.fromDto,
    [AnswerType.GAP_MATCH]: GapMatchAnswer.fromDto,
    [AnswerType.LIST]: ListAnswer.fromDto,
    [AnswerType.KEYWORD]: KeywordAnswer.fromDto,
    [AnswerType.READING]: ReadingAnswer.fromDto,
  };

  public static fromDto(dto: any): Answer {
    const mapper: ((dto: any) => Answer) | undefined =
      AnswerMapper.mappers[dto.type];
    if (!mapper) {
      throw new Error(`Unknown answer type: ${dto.type}`);
    }
    return mapper(dto);
  }
}
